import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import loginHelper from './loginHelper';
import applicationMenuActionHelper from './applicationMenuActionHelper';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width: '470px',
        padding: '24px',
        borderRadius: '10px'
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        '& li': {
            listStyle: 'disc',
        },
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
        justifyContent: 'space-between'
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2, fontSize: '28px !important' }} {...other}>
            {children}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function SessionExpiredDialog({ open, setOpen }) {
    const handleClose = (event, reason) => {
        const isUnauthorized = loginHelper.getUnauthorizedAction();
        if (isUnauthorized) {
            setOpen(false);
            loginHelper.deleteUnauthorizedAction();
            applicationMenuActionHelper.deleteApplicationMenuAction();
            window.location.href = "/Dashboard";
            return;
        }
        if (reason !== 'backdropClick') {
            setOpen(false);
            sessionStorage.clear();
            loginHelper.deleteLoginInfo();
            window.location.pathname = "/";
        }
    };

    const getExpiredMessage = () => {
        const isUnauthorized = loginHelper.getUnauthorizedAction();
        const displayedMessage = isUnauthorized? "You do not have access right to access the resource.": "Session expired.";
        return displayedMessage;
    }

    return (<>
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            disableEscapeKeyDown
        >
            <BootstrapDialogTitle id="customized-dialog-title"
                variant='h3'
                onClose={handleClose}>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    {getExpiredMessage()}
                </div>
            </BootstrapDialogTitle>
            <DialogContent /*dividers*/>
                <Typography gutterBottom
                    className='font-normal-mine-shaft-16px'>
                    
                </Typography>
            </DialogContent>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <DialogActions>
                    <Button onClick={handleClose}
                        className='button-large font-bold-white-16px'
                    >
                        OK
                    </Button>
                </DialogActions>
            </div>
        </BootstrapDialog>
    </>)
}